function fn_comp_map() {
    var $fn = $(".comp_map");

    if($fn.length) {
        var $map = $fn.find(".elm_map");
        if($map.length){
            function fn_part_filter_map() {
                $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBBpAql0KMPm89qZZARhPEl-DKRBxZEhE8&_=1493306261290")
                    .done(function () {
                        $map.nl_google_map('init');
                        $map.nl_google_map('markers_add');
                    });
            }
            fn_part_filter_map();
        }
    }
}
